/**
 * Mensagens de erro para o cidadão: texto principal simples, sem jargão; o
 * código técnico (HTTP etc.) vai num detalhe menor.
 */
import { HttpError } from './net';

export interface FriendlyError {
  message: string;
  /** Detalhe técnico curto (exibido em letra menor), ou null. */
  detail: string | null;
}

function httpStatus(e: unknown, raw: string): number | null {
  if (e instanceof HttpError) return e.status;
  const m = /HTTP (\d{3})/.exec(raw); // erros vindos do Web Worker chegam só com a mensagem
  return m ? Number(m[1]) : null;
}

export function describeError(e: unknown): FriendlyError {
  const raw = e instanceof Error ? e.message : String(e);
  const status = httpStatus(e, raw);
  if (status === 404) {
    return { message: 'O INPE não está publicando os arquivos de focos neste momento. Tente de novo mais tarde.', detail: 'HTTP 404' };
  }
  if (status !== null && status >= 500) {
    return { message: 'O servidor do INPE está com problemas no momento. Tente de novo em instantes.', detail: `HTTP ${status}` };
  }
  if (status !== null) {
    return { message: 'O servidor do INPE não atendeu o pedido. Tente de novo mais tarde.', detail: `HTTP ${status}` };
  }
  if (e instanceof TypeError || /Failed to fetch|NetworkError|Load failed|network/i.test(raw)) {
    return { message: 'Não foi possível acessar o servidor do INPE. Verifique a conexão e tente de novo.', detail: null };
  }
  if (/colunas|formato/i.test(raw)) {
    return { message: 'Os arquivos do INPE vieram num formato inesperado. Tente de novo mais tarde.', detail: raw };
  }
  return { message: 'Não foi possível carregar os focos do INPE agora. Tente de novo.', detail: raw };
}
